module.exports = __webpack_public_path__ + "img/asertivoro.da0da4ed.png";